import { type ButtonHTMLAttributes, type FC, type ReactNode } from 'react';
import { Button as CNButton } from 'components/ui/button';
import { cn } from '@/lib/utils';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  className?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  fullWidth?: boolean;
  isActive?: boolean;
}

const MenuBtn: FC<Props> = ({
  children,
  className,
  endIcon,
  fullWidth,
  isActive,
  onClick,
  startIcon,
}) => {
  return (
    <CNButton
      className={cn(
        'hc:flex hc:bg-grey-100 hc:dark:bg-muted hc:hover:bg-grey-200 hc:dark:hover:bg-grey-700',
        fullWidth
          ? 'hc:w-full!'
          : children && typeof children === 'string' && children.length > 12
            ? ''
            : 'hc:w-fit',
        className
      )}
      variant={'secondary'}
      onClick={onClick}>
      <span className={cn('hc:relative hc:flex hc:items-center hc:justify-between hc:w-full')}>
        <div className='hc:flex hc:items-center hc:gap-2'>
          {startIcon && <span>{startIcon}</span>}
          <span
            className={cn(
              'hc:text-left hc:whitespace-normal hc:text-sm hc:font-semibold',
              isActive
                ? 'hc:text-typography-dark hc:dark:text-white'
                : 'hc:text-typography-secondary hc:dark:text-grey-300'
            )}>
            {children}
          </span>
        </div>
        {endIcon && <span className='hc:ml-2'>{endIcon}</span>}
      </span>
    </CNButton>
  );
};
export default MenuBtn;
